import * as React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Dropdown from 'react-bootstrap/Dropdown';
import Image from 'react-bootstrap/Image';
import Swoosh from '../../../media/swoosh.png';
import Badge from 'react-bootstrap/Badge';
import AboutModal from './AboutModal';
import Dialog from '../../../utilities/Dialog'
import { Link } from 'react-router-dom';
import axios from 'axios';
import { connect } from 'react-redux';
import { logout, MetaData } from '../../../store/user/actions';
import { AppState } from '../../../store';
import ServerStatus from '../../common/ServerStatus';
import MsalAuth from '../../../utilities/msalAuth';
import { updateSavedFilters, updateFavorites, editFavoriteName } from '../../../store/user/actions';
import AxiosConfig from '../../../utilities/AxiosConfig';
//!!!r-18-dj
//@ts-ignore
import { withRouter } from 'react-router-dom';
import Notifications from 'src/utilities/Notifications/Notifications';
import mutator from 'src/utilities/mutator';
import LogoutButton from 'src/auth/logout/Logout';
import './NavigationBarStyles.css';

type Props = {
    logout: typeof logout;
    username: string;
    UserSettings: any;
    history: any;
    location: any;
    match: any;
    userId: number | string;
    removeNotification: Function;
    updateSavedFilters: any;
    updateFavorites: any;
    editFavoriteName: any;
    addVisibleNotification: any;
    populateNotifications: any;
}

type State = {
    showNotifications: boolean;
    searchTerm: string;
    aboutOpen: boolean;
    defaultPageNag: boolean;
    profilePic: any;
    helpForm: string;
}

class NavigationBar extends React.Component<Props, State>{
    slot: string | undefined;
    constructor(props: Props) {
        super(props);
        this.state = {
            showNotifications: false,
            searchTerm: "",
            aboutOpen: false,
            defaultPageNag: false,
            profilePic: null,
            helpForm: ""
        }
        this.slot = process.env.REACT_APP_SLOT
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        let split: Array<string> = this.props.location.pathname.split("/");
        let basePath: string = "";
        if (split.length >= 3) {// it has two key fields such as /hr/employees -> keys = hr and employees
            basePath = split[1] + "-" + split[2]
        } else if (split.length === 2) {// Path has one key such as /release
            basePath = split[1];
        }
        const formName: string = "DOC-" + basePath;
        if (formName !== this.state.helpForm) {
            this.setState({ helpForm: formName });
        }
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(mutator.mutate(this.state, keys))
    }

    changeColors = () => {
        let c = this.props.UserSettings?.Color || "dark";
        let color = (c === "dark" ? "elmblue" : "dark");
        let oldUserSettings = { ...MsalAuth.Settings["UserSettings"] };
        let newSettings = {
            ...MsalAuth.Settings,
            UserSettings: {
                ...oldUserSettings,
                "Color": color
            }
        };
        MsalAuth.updateUserSettings({ ...oldUserSettings, Color: color });
        axios.post(process.env.REACT_APP_API_URL + "/api/Settings", newSettings, { headers: { Authorization: `bearer ${AxiosConfig.tokenValue()}` } })
            .then((response: any) => {
                // //console.log("response", response)
            })
            .catch((error: any) => {
                //console.log("error", error);
                AxiosConfig.handleError(error);
            })
    }

    changeDefaultPage = async () => {
        // //console.log("CHANGEDEFAULTPAGE", this.props.history);
        let c: any = new Dialog({ message: `Set this page as Default Page?` });
        let answer: boolean = await c.show();
        if (answer) {
            let oldUserSettings = MsalAuth.UserSettings();
            MsalAuth.updateUserSettings({ ...oldUserSettings, defaultRedirect: this.props.location.pathname });
        }
    }

    getClass = () => {
        switch (this.slot) {
            case "STAGING":
                return "bg-staging";
            case "DEV":
                return "bg-success";
            case "EXPERIMENTAL":
                return "bg-experimental";
            default:
                return "";
        }
    }

    deleteFavorite = async (e: React.SyntheticEvent, metaData: MetaData) => {
        e.preventDefault();
        const prompt: any = new Dialog({ type: "confirm", message: `Are you sure you want to delete ${metaData.name}?`, trueText: "Yes", falseText: "No" });
        const answer: any = await prompt.show();
        if (answer) {
            this.props.updateFavorites(metaData, true);
            metaData.hasFilter && this.props.updateSavedFilters(metaData.category, metaData.name, {}, true);
        }
    }

    handleEditFavoriteName = async (e: React.SyntheticEvent, metaData: MetaData) => {
        e.preventDefault();
        const prompt: any = new Dialog({ type: "prompt", message: "Enter the new favorite name to continue.", trueText: "Submit", falseText: "Cancel" });
        const answer: string = await prompt.show();
        if (answer) {
            this.props.editFavoriteName(metaData, answer);
        }
    }

    handleBookmark = (e: React.MouseEvent) => {
        e.preventDefault();
        let path: Array<string> = this.props.location.pathname.split("/");
        path.shift();
    }

    getProfilePic = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/user/getProfilePic/" + this.props.userId, AxiosConfig.configValue("min"))
            .then((response: any) => {
                if (response.data.profilePic.length > 0) {
                    this.setState({ profilePic: response.data.profilePic[0].imageFullUrl })
                }

            })
            .catch((error: any) => {
                //console.log("error", error);
                AxiosConfig.handleError(error);
            })
    }

    render() {
        const { username } = this.props;
        const aboutOpen = this.state.aboutOpen

        return (
            <>
                <Navbar className={`top-nav d-flex flex-row justify-content-between ${this.getClass() ? this.getClass() : `bg-${this.props.UserSettings?.Color || "dark"}`}`} sticky="top" expand="md" variant="dark">
                    <Navbar.Toggle aria-controls="navbar" style={{ border: "none" }} className="no-focus-outline" />
                    <Navbar.Brand href="#" as={Link} to="/" className="p-0 m-0 d-flex flex-row justify-content-between align-items-center">
                        <div className="d-flex flex-row justify-content-center align-items-center">
                            <Image data-testid="navigation-logo" className="pr-2" id="navigation-logo" src={Swoosh} alt="Logo" style={{ height: "48px" }} />
                            LaunchPoint
                        </div>
                        <Badge title={`Version: ${process.env.REACT_APP_VERSION}`} className="ml-1 d-none d-md-block" variant="secondary">{process.env.REACT_APP_VERSION}</Badge>
                        <ServerStatus wrapperClassName="ml-2" />
                        {MsalAuth.LogRocketActive && <i title="Troubleshooting On" className="material-icons text-success">bug_report</i>}
                        {/* <Breadcrumbs />   */}
                        {/* If breadcrumbs are ever ready uncomment this */}
                    </Navbar.Brand>
                    <Navbar.Collapse id="navbar" className={this.getClass() ? this.getClass() : `collapsed-menu-${this.props.UserSettings?.Color || "dark"}`}>
                        <Nav className="mr-auto">
                            {/* If we want something on the left add it here */}
                        </Nav>
                        <Nav className="d-flex flex-column flex-md-row flex-xs-column justify-content-center align-items-center">
                            {/* <Search /> */}
                            <Nav.Link as={Dropdown} data-title="Settings" className="d-flex flex-column cursor-on-hover m-0 p-0 collapsed-nav-item" alignRight>
                                <Dropdown.Toggle id="settings-drop" as={Nav.Link} className="remove-dropdown-arrow d-flex">
                                    <i className="material-icons">settings</i>
                                    <h5 className="d-md-none d-xs-block ml-2">Settings</h5>
                                </Dropdown.Toggle>
                                <Dropdown.Menu flip className="collapsed-dropdown">
                                    <Dropdown.Item disabled className="d-flex align-items-center justify-content-start">
                                        Settings
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                    <Dropdown.Item className="d-flex align-items-center justify-content-start" onClick={this.changeColors}>
                                        <i className="material-icons">color_lens</i>
                                        Change Color
                                    </Dropdown.Item>
                                    {
                                        (process.env.REACT_APP_SLOT === "STAGING" || process.env.REACT_APP_SLOT === "DEV") &&
                                        <Dropdown.Item className="d-flex align-items-center justify-content-start" onClick={() => {
                                            this.slot ? this.slot = "" : this.slot = process.env.REACT_APP_SLOT;
                                            this.forceUpdate();
                                        }}>
                                            <i className="material-icons">{this.slot ? "invert_colors_off" : "invert_colors"}</i>
                                            Turn {this.slot ? "off" : "on"} slot color
                                        </Dropdown.Item>
                                    }
                                    <Dropdown.Item onClick={() => this.changeDefaultPage()} className="d-flex align-items-center justify-content-start">
                                        <i className="material-icons">book</i>
                                        Set Current as Default Page
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Nav.Link>

                            <Nav.Link className="mr-2 d-flex collapsed-nav-item" as={Link} to="/" href="#link">
                                <i className="material-icons">home</i>
                                <h5 className="d-md-none d-xs-block ml-2">Home</h5>
                            </Nav.Link>

                            <Notifications
                                userId={this.props.userId}
                            />

                            <Dropdown
                                id="profile-dropdown"
                                //!!!r-18-dj
                                //@ts-ignore
                                alignRight
                                drop="down"
                                title={`Logged in as ${this.props.username}`}
                                className="d-flex flex-column justify-content-center align-items-center cursor-on-hover collapsed-nav-item"
                            >
                                <Dropdown.Toggle
                                    id="profile-btn"
                                    as={Image}
                                    src={this.state.profilePic || process.env.PUBLIC_URL + '/defaultProfile.jpg'}
                                    roundedCircle={true}
                                    className="profile-button mr-3"
                                >
                                </Dropdown.Toggle>
                                <Dropdown.Menu flip className="mt-2 mr-2 collapsed-dropdown">
                                    <Dropdown.Item disabled className="d-flex">
                                        <div id="profile-dropdown-header">
                                            Hello, {username}!
                                        </div>
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                    <Dropdown.Item onClick={() => this.manageState([{ key: "aboutOpen", value: true }])}>
                                        <div className="d-flex">
                                            <i className="material-icons mr-1">info</i>
                                            About
                                        </div>
                                    </Dropdown.Item>
                                    <AboutModal onHide={() => this.setState({ aboutOpen: false })} show={aboutOpen} />
                                    <Dropdown.Divider />
                                    <Dropdown.Item>
                                        <div className="d-flex">
                                            {/* <i className="material-icons mr-1">warning</i>
                                            Sign Out */}
                                            <LogoutButton/>
                                        </div>
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    userId: state.user.userId,
    username: state.user.userName,
    UserSettings: state.user.UserSettings
})

let connected: any = connect(mapStateToProps, {
    logout,
    updateSavedFilters,
    updateFavorites,
    editFavoriteName,
})(NavigationBar);

export default withRouter(connected);
